import { ConfirmationDialogStyled } from './ConfirmationDialog'
import { DangerButton, PrimaryBtnOutline } from '../Buttons'
import { useZoomContext } from '../../context/ZoomContext'
import { useContentSharing } from '../../context/ContentSharingContext'
import { useTranslation } from 'react-i18next'

interface StopSharingModalProps {
    onConfirm: () => void;
    onCancel: () => void;
}

const StopSharingModal = ({ onConfirm, onCancel }: StopSharingModalProps) => {
    const { t } = useTranslation('meeting')

    return (
        <ConfirmationDialogStyled>
            <div className="info">
                <h2>{t('stopSharingModal.title', 'Stop Sharing Content?')}</h2>
                <div>
                    <p>{t('stopSharingModal.confirmStop', 'Are you sure you want to stop sharing content with other participants?')}</p>
                </div>
            </div>
            <div className="actions">
                <DangerButton onClick={onConfirm}>
                    {t('stopSharingModal.stopButton', 'Stop Sharing')}
                </DangerButton>
                <PrimaryBtnOutline onClick={onCancel} colorTheme={'light'}>
                    {t('stopSharingModal.cancelButton', 'Continue Sharing')}
                </PrimaryBtnOutline>
            </div>
        </ConfirmationDialogStyled>
    )
}

export default StopSharingModal 